module.exports = __webpack_public_path__ + "static/media/shingleMoireBlack.c3bf4227.png";